<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat v-if="coreValue">
      <v-card-title>
        You've selected
        <span class="primary--text ml-1">{{
          coreValue.categoryName | lower
        }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        <template v-if="coreValue.id">
          Customize the name of your {{ t("core_values.title_s") | lower }}
        </template>
        <template v-else>
          Before we add it to your company, would you like to modify the name?
        </template>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container class="py-0">
            <v-row>
              <v-col cols="auto" v-if="coreValue.badgeUrl">
                <v-card
                  outlined
                  class="option-card background text-center px-4 pt-4"
                  height="100%"
                >
                  <v-icon color="primary">
                    check_circle
                  </v-icon>
                  <inline-svg
                    :width="80"
                    :height="80"
                    :fill="$vuetify.theme.themes.light.primary"
                    :src="coreValue.badgeUrl"
                    class="badge-image"
                  />
                </v-card>
              </v-col>
              <v-col class="my-auto">
                <v-text-field
                  v-model="coreValue.name"
                  label="Customize name"
                  outlined
                  :rules="[$rules.required]"
                  maxlength="50"
                >
                </v-text-field>
                <v-btn @click="save" :loading="saving">Save</v-btn>
                <v-btn text v-if="coreValue.id" @click="deleteCoreValue"
                  >Delete</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "AddCoreValueDialog",
  components: {
    "inline-svg": InlineSvg
  },
  props: { coreValue: { type: Object } },
  data: () => ({
    dialog: false,
    valid: false,
    saving: false
  }),
  watch: {
    coreValue: function(val) {
      if (val) {
        this.dialog = true;
      }
    }
  },
  computed: {},
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("company/saveCoreValues", [this.coreValue])
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess(
              `${this.t("core_values.title_s")} saved`
            );
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving"
            );
          });
      }
    },
    async deleteCoreValue() {
      if (
        await this.$root.$confirm(
          `Delete ${this.t("core_values.title_s", true)}`,
          `Are you sure you want to delete this ${this.t(
            "core_values.title_s",
            true
          )}?<br><br>All reporting data will be lost if this ${this.t(
            "core_values.title_s",
            true
          )} is deleted`,
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("company/deleteCoreValue", this.coreValue.id)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess(
              `${this.t("core_values.title_s")} deleted`
            );
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while saving"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-image {
  margin-top: 8px;
}
</style>
